import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7ec29c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-authorised-signatories" }
const _hoisted_2 = {
  key: 2,
  class: "container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Managed Authorised Signatories")
  ])
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12" }

export function render(_ctx, _cache) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_FirmSelector = _resolveComponent("FirmSelector")
  const _component_PracticePeopleSignatories = _resolveComponent("PracticePeopleSignatories")
  const _component_LoggedInElsewhere = _resolveComponent("LoggedInElsewhere")
  const _component_SessionExpired = _resolveComponent("SessionExpired")
  const _component_AccessDenied = _resolveComponent("AccessDenied")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoadingPractices)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : (!_ctx.selectedPractice)
        ? (_openBlock(), _createBlock(_component_FirmSelector, {
            key: 1,
            practices: _ctx.practices,
            onSelectedPractice: _ctx.setSelectedPractice
          }, null, 8, ["practices", "onSelectedPractice"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_PracticePeopleSignatories, {
                  selectedPractice: _ctx.selectedPractice,
                  practices: _ctx.practices,
                  onOnSelectedPracticeChange: _ctx.setSelectedPractice,
                  onConcurrencyError: _ctx.handleError,
                  onStatusChange: _ctx.loadingStateChanged
                }, null, 8, ["selectedPractice", "practices", "onOnSelectedPracticeChange", "onConcurrencyError", "onStatusChange"])
              ])
            ]),
            (_ctx.showLoggedInElsewhereModal)
              ? (_openBlock(), _createBlock(_component_LoggedInElsewhere, {
                  key: 0,
                  additionalMsg: false,
                  modalOpened: _ctx.showLoggedInElsewhereModal,
                  onClose: _cache[0] || (_cache[0] = $event => (_ctx.closeLoggedInElsewhereModal())),
                  onContinue: _cache[1] || (_cache[1] = $event => (_ctx.proceedToOvertakeSession()))
                }, null, 8, ["modalOpened"]))
              : _createCommentVNode("", true),
            (_ctx.showSessionExpiredModal)
              ? (_openBlock(), _createBlock(_component_SessionExpired, {
                  key: 1,
                  modalOpened: _ctx.showSessionExpiredModal,
                  onClose: _cache[2] || (_cache[2] = $event => (_ctx.exitPage()))
                }, null, 8, ["modalOpened"]))
              : _createCommentVNode("", true),
            (_ctx.showAccessDeniedModal)
              ? (_openBlock(), _createBlock(_component_AccessDenied, {
                  key: 2,
                  modalOpened: _ctx.showAccessDeniedModal,
                  typeA: _ctx.typeA,
                  typeB: _ctx.typeB,
                  typeC: _ctx.typeC,
                  firstNameProp: _ctx.firstNameProp,
                  lastNameProp: _ctx.lastNameProp,
                  onClose: _cache[3] || (_cache[3] = $event => (_ctx.closeAccessDeniedModal()))
                }, null, 8, ["modalOpened", "typeA", "typeB", "typeC", "firstNameProp", "lastNameProp"]))
              : _createCommentVNode("", true)
          ]))
  ]))
}